import { SaleDetailsDto } from "./sale-details.dto";

export class AssetsSaleDto{
    assetSaleId:number ;
    saleDetails : SaleDetailsDto[];
    isActive: boolean;
    constructor(
        assetSaleId:number,
        saleDetails : SaleDetailsDto[],
        isActive: boolean,
         ){
        this.assetSaleId = assetSaleId;
        this.saleDetails = saleDetails;
        this.isActive = isActive;
    }
}